<h5>{{title}}</h5>
<form [formGroup]="billofladingAddressForm">
  <div class="form-row">
    <div class="form-group col-md-6">
      <div class="row">
        <div class="col-md-12">
          <label for="Line1">Line1</label>
          <input type="text" id="Line1" class="w-100" formControlName="line1">
        </div>
      </div>
    </div>
  </div>
  <div class="form-row">
    <div class="form-group col-md-6">
      <div class="row">
        <div class="col-md-12">
          <label for="Line2">Line2</label>
          <input type="text" id="Line2" class="w-100" formControlName="line2">
        </div>
      </div>
    </div>
  </div>
    <div class="form-row">
      <div class="form-group col-md-6">
        <div class="row">
          <div class="col-md-12">
            <label for="City">City</label>
            <input type="text" id="City" class="w-100" formControlName="city">
          </div>
        </div>
      </div>
    </div>
  <div class="form-row">
    <div class="form-group col-md-6">
      <div class="row">
        <div class="col-md-12">
          <label for="state">State</label>
          <input type="text" id="state" class="w-100" formControlName="state">
        </div>
      </div>
    </div>
  </div>
  <div class="form-row">
    <div class="form-group col-md-6">
      <div class="row">
        <div class="col-md-12">
          <label for="zip">Zip</label>
          <input type="text" id="zip" class="w-100" formControlName="zip">
        </div>
      </div>
    </div>
  </div>
  <div class="form-row">
    <div class="form-group col-md-6">
      <div class="row">
        <div class="col-md-12">
          <label for="Phone">Phone</label>
          <input type="text" id="Phone" class="w-100" formControlName="phone">
        </div>
      </div>
    </div>
  </div>
  <div class="form-row">
    <div class="form-group col-md-6">
      <div class="row">
        <div class="col-md-12">
          <label for="AltPhone">Alternate Phone</label>
          <input type="text" id="AltPhone" class="w-100" formControlName="altPhone">
        </div>
      </div>
    </div>
  </div>
  <div class="form-row">
    <div class="form-group col-md-6">
      <div class="row">
        <div class="col-md-12">
          <label for="Email">Email</label>
          <input type="text" id="Email" class="w-100" formControlName="email">
        </div>
      </div>
    </div>
  </div>
  <!-- <div class="form-row">
    <div class="form-group col-md-6">
      <div class="row">
        <div class="col-md-12">
          <label for="OtherContactInfo">Other Contact Information</label>
          <input type="text" id="OtherContactInfo" class="w-100" formControlName="otherContactInfo">
        </div>
      </div>
    </div>
  </div> -->
</form>